import TimeIntervalSelector from './Component';
import { INITIAL_TIME_INTERVAL } from './constants';

export { INITIAL_TIME_INTERVAL };
export default TimeIntervalSelector;
